import ModalTemplate from "components/modal/modal-template";
import Typography from "components/typography";
import { albumCover } from "constants/placeholderAlbumCover";
import React, { useState } from "react";
import styled from "styled-components";
import { Colors } from "utils/colors";
import { ReactComponent as InstagramIcon } from "images/svg/share-icons/Instagram-logo.svg";
import { ReactComponent as XIcon } from "images/svg/share-icons/x-logo.svg";
import { ReactComponent as FacebookIcon } from "images/svg/share-icons/Facebook-logo.svg";
import { ReactComponent as WhatsappIcon } from "images/svg/share-icons/whatsapp-logo.svg";
import { ReactComponent as SnapchatIcon } from "images/svg/share-icons/Snapchat-logo.svg";
import { ReactComponent as ThreadsIcon } from "images/svg/share-icons/threads-logo.svg";
import { ReactComponent as TelegramIcon } from "images/svg/share-icons/telegram-logo.svg";
import { ReactComponent as LinkedInIcon } from "images/svg/share-icons/LinkedIn-logo.svg";

interface IProps {
  closeModal: () => void;
}
const ShareModal = ({ closeModal }: IProps) => {
  const [isCopied, setIsCopied] = useState(false);
  const [shareHover, setShareHover] = useState(false);

  const handleSharing = async () => {
    if (navigator.share) {
      try {
        await navigator
          .share({
            url: "https://rated-afrika.vercel.app",
            title: "My song is out on Rated Afrika",
            text: "Check it out !"
          })
          .then(() =>
            console.log("Hooray! Your content was shared to tha world")
          );
      } catch (error) {
        console.log(`Oops! I couldn't share to the world because: ${error}`);
      }
    } else {
      // fallback code
      console.log(
        "Web share is currently not supported on this browser. Please provide a callback"
      );
    }
  };

  //note: handle social media sharing
  const ShareLinks = [
    {
      icon: (
        <GrayIcon>
          <InnerGrayIcon>
            {isCopied ? (
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="100%"
                height="100%"
                viewBox="0 0 24 24"
                fill="none"
              >
                <path
                  d="M5 14L8.5 17.5L19 6.5"
                  stroke="#5AB400"
                  stroke-width="1.5"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
            ) : (
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="100%"
                height="100%"
                viewBox="0 0 24 24"
                fill="none"
              >
                <path
                  d="M14 12C14 15.3137 11.3137 18 8 18C4.68629 18 2 15.3137 2 12C2 8.68629 4.68629 6 8 6"
                  stroke="#CDCDCD"
                  stroke-width="1.5"
                  stroke-linecap="round"
                />
                <path
                  d="M10 12C10 8.68629 12.6863 6 16 6C19.3137 6 22 8.68629 22 12C22 15.3137 19.3137 18 16 18"
                  stroke="#CDCDCD"
                  stroke-width="1.5"
                  stroke-linecap="round"
                />
              </svg>
            )}
          </InnerGrayIcon>
        </GrayIcon>
      ),
      name: isCopied ? "Copied" : "Copy Link",
      onClick: () => {
        navigator.clipboard.writeText("link");
        setIsCopied(true);
      }
    },
    {
      icon: <InstagramIcon />,
      name: "Instagram",
      onClick: () => {}
    },
    {
      icon: <XIcon />,
      name: "x",
      onClick: () => {}
    },
    {
      icon: <FacebookIcon />,
      name: "Facebook",
      onClick: () => {}
    },
    {
      icon: <WhatsappIcon />,
      name: "Whatsapp",
      onClick: () => {}
    },
    {
      icon: <SnapchatIcon />,
      name: "Snapchat",
      onClick: () => {}
    },
    {
      icon: <ThreadsIcon />,
      name: "Threads",
      onClick: () => {}
    },
    {
      icon: <TelegramIcon />,
      name: "Telegram",
      onClick: () => {}
    },
    {
      icon: <LinkedInIcon />,
      name: "Linkedin",
      onClick: () => {}
    },
    {
      icon: (
        <GrayIcon>
          <InnerGrayIcon>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="100%"
              height="100%"
              viewBox="0 0 20 20"
              fill="none"
            >
              <path
                d="M15 5.8335C15.6454 5.96731 16.1323 6.19065 16.5237 6.5634C17.5 7.49334 17.5 8.99008 17.5 11.9835C17.5 14.9769 17.5 16.4736 16.5237 17.4036C15.5474 18.3335 13.976 18.3335 10.8333 18.3335H9.16667C6.02397 18.3335 4.45262 18.3335 3.47631 17.4036C2.5 16.4736 2.5 14.9769 2.5 11.9835C2.5 8.99008 2.5 7.49334 3.47631 6.5634C3.86765 6.19065 4.35458 5.96731 5 5.8335"
                stroke="#CDCDCD"
                stroke-width="1.25"
                stroke-linecap="round"
              />
              <path
                d="M10.0211 1.66718L10 11.6668M10.0211 1.66718C9.88558 1.66158 9.74925 1.71001 9.62775 1.81252C8.87242 2.45013 7.5 4.10747 7.5 4.10747M10.0211 1.66718C10.1426 1.67223 10.2635 1.72072 10.3723 1.81265C11.1276 2.45039 12.5 4.10747 12.5 4.10747"
                stroke="#CDCDCD"
                stroke-width="1.25"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
          </InnerGrayIcon>
        </GrayIcon>
      ),
      name: "More",
      onClick: () => {
        handleSharing();
      }
    }
  ];

  const [translateIndex, setTranslateIndex] = useState(0);
  return (
    <ModalTemplate
      header="Share RAted Fans Link"
      close={closeModal}
      footer={false}
      width="44.8rem"
    >
      <Body>
        <Typography size="lg" weight="semibold" mb="0.8">
          Blueberry Faygo
        </Typography>
        <Typography size="s" mb="1.6">
          Lil Mosey
        </Typography>
        <CoverImage src={albumCover} alt="cover-img" />
        <LinksContainer
          onMouseEnter={() => setShareHover(true)}
          onMouseLeave={() => setShareHover(false)}
        >
          {shareHover && translateIndex !== 0 && (
            <NavButton onClick={() => setTranslateIndex(translateIndex - 1)}>
              <NavInner>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="100%"
                  height="100%"
                  viewBox="0 0 17 17"
                  fill="none"
                >
                  <path
                    d="M10.5 5.16663L6.5 8.49996L10.5 12.1666"
                    stroke="#CDCDCD"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
              </NavInner>
            </NavButton>
          )}

          {shareHover && translateIndex < 5 && (
            <NavButton
              onClick={() => setTranslateIndex(translateIndex + 1)}
              style={{ left: "unset", right: "0" }}
            >
              <NavInner>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="100%"
                  height="100%"
                  viewBox="0 0 16 17"
                  fill="none"
                >
                  <path
                    d="M6 5.16663L10 8.49996L6 12.1666"
                    stroke="#CDCDCD"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
              </NavInner>
            </NavButton>
          )}

          <TranslateContainer translateindex={translateIndex}>
            {ShareLinks.map(({ icon, name, onClick }, i) => {
              return (
                <ShareItem key={i} onClick={onClick}>
                  <Icon>{icon}</Icon>
                  <Typography
                    mt="0.8"
                    size="s"
                    color={name === "Copied" ? Colors.success : "inherit"}
                  >
                    {name}
                  </Typography>
                </ShareItem>
              );
            })}
          </TranslateContainer>
        </LinksContainer>
      </Body>
    </ModalTemplate>
  );
};

export default ShareModal;

const Body = styled.div`
  display: flex;
  align-items: center;
  flex-direction: column;
`;
const CoverImage = styled.img`
  width: 40rem;
  height: 40rem;
  border-radius: 0.8rem;
  margin-bottom: 4rem;
`;

const LinksContainer = styled.div`
  position: relative;
  width: 100%;
  @media only screen and (max-width: 769px) {
    overflow-x: scroll;
  }
`;

const TranslateContainer = styled.div<{ translateindex: number }>`
  width: fit-content;
  display: flex;
  align-items: center;
  overflow-x: scroll;
  transition: ease-in 0.2s all;
  transform: ${(props) => `translateX(${-props.translateindex * 7.6}rem)`};
`;

const ShareItem = styled.div`
  cursor: pointer;
  margin-right: 1.6rem;
  display: flex;
  align-items: center;
  flex-direction: column;
  color: ${Colors.grey200};
  width: 6rem;
`;
const Icon = styled.div`
  width: 4.8rem;
  height: 4.8rem;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const GrayIcon = styled(Icon)`
  border-radius: 50%;
  background-color: ${Colors.grey700};
`;

const InnerGrayIcon = styled.div`
  width: 2.4rem;
  height: 2.4rem;
`;

const NavButton = styled.div`
  position: absolute;
  width: 3.2rem;
  height: 3.2rem;
  border-radius: 50%;
  background-color: ${Colors.grey600};
  cursor: pointer;
  top: 2rem;
  left: 0;
  z-index: 2;
  display: flex;
  align-items: center;
  justify-content: center;
  @media only screen and (max-width: 769px) {
    display: none;
  }
`;

const NavInner = styled.div`
  width: 1.6rem;
  height: 1.6rem;
`;
